import React, { useMemo } from 'react';
import { graphql, useStaticQuery } from 'gatsby';

import Layout from '../components/layout';
import { getFluidGatsbyImage } from '../utils/gatsby-storyblok-image-fixed/';
import { useProductCategories } from '../hooks/use-product-categories';
import parseStoryblokLink from '../utils/parse-storyblok-link';
import ProductFilter from '../components/product-filter';

export default function ProductsCategoryPage({ pageContext }) {
  const { categorySlug, categoryName, searchData } = pageContext;

  const { items, productsRoot } = useStaticQuery(graphql`
    query ProductsCategoryQuery {
      items: allStoryblokEntry(
        filter: { field_component: { eq: "product" } }
        sort: { fields: [position] }
      ) {
        edges {
          node {
            position
            name
            full_slug
            content
          }
        }
      }
      productsRoot: storyblokEntry(field_component: { eq: "productsRoot" }) {
        content
      }
    }
  `);

  const categories = useProductCategories();

  const currentCategory = useMemo(() => {
    return (
      categories.find((c) => c.slug === categorySlug) || {
        name: categoryName,
        slug: categorySlug
      }
    );
  }, [categories, categorySlug, categoryName]);

  const itemsParsed = useMemo(() => {
    return items.edges
      .map((productData) => {
        const product = JSON.parse(productData.node.content);

        const fluidProductImage =
          !!product.productThumbnail &&
          getFluidGatsbyImage(product.productThumbnail, {
            maxWidth: 550
          });

        return {
          image: fluidProductImage,
          name: product.productName,
          link: parseStoryblokLink(productData.node.full_slug),
          position: productData.node.position,
          ...product
        };
      })
      .filter((item) => item.category && item.category.slug === categorySlug);
  }, [items, categorySlug]);

  const productsRootContent = productsRoot
    ? JSON.parse(productsRoot.content)
    : {};

  const pathname = `/products/${categorySlug}/`;

  return (
    <Layout
      seoTitle={`${categoryName} Products`}
      seoDescription={productsRootContent.seoDescription}
      seoPathname={pathname}
      searchData={searchData}
    >
      <ProductFilter
        items={itemsParsed}
        title={productsRootContent.title}
        subtitle={productsRootContent.subtitle}
        paragraph={productsRootContent.paragraph}
        categories={categories}
        initialCategory={currentCategory}
        usePathBasedNavigation
      />
    </Layout>
  );
}
